module.exports = __webpack_public_path__ + "img/ih1.cf789b23.png";